/*********************************************************************************************************************/
/*Only Three things updated in local Storage First and Last Name and Image Url as only these are taken from the local
 storage on subsequent refresh page. If any other updated data is needed in any other part of the web app...Kindly
 USE GetByID  For User to get it*/
/*********************************************************************************************************************/
(function() {
    angular.module('tmx-app').controller('profileLinkCtrl', ['CurrentUserService','ProfileLinkService', 'resolvedData', '$state',
        'UsersService','$stateParams','$scope','ServerExceptionService','menu', ProfileLinkCtrl]);

    function ProfileLinkCtrl(CurrentUserService,ProfileLinkService, resolvedData, $state, UsersService, $stateParams,$scope,ServerExceptionService,menu) {
        var profileVM = this;
         
        profileVM.config = {};
        profileVM.user = {};
        profileVM.hide=false;
        profileVM.user = {};//resolvedData.User.data;
        profileVM.name = false;
        //profileVM.dataLoading=true;
        profileVM.menu=menu;


        //////////////////////////FUNCTIONS////////////////////////////////////////////////////////////////////////
        profileVM.onChildState = function() {
            if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            else return false;
        };
        profileVM.clickEdit = function() {
          //  profileVM.expandField(val);
           // hide();
            $state.go($state.current.name + ".edit", {
                "Id": profileVM.user.UserId
            });

        };
        profileVM.expandField = function(val) {
            for (i = 0; i < profileVM.profileFields.length; i++) {
                if (profileVM.profileFields[i].name == val) profileVM.profileFields[i].expanded = true;
                else {
                    profileVM.profileFields[i].expanded = false;
                }
            }
        };
        profileVM.cancelExpansion = function(val) {
            for (i = 0; i < profileVM.profileFields.length; i++) {
                if (profileVM.profileFields[i].name == val) profileVM.profileFields[i].expanded = false;
            }
        };
        profileVM.saveData = function(val) {
            for (i = 0; i < profileVM.profileFields.length; i++) {
                if (profileVM.profileFields[i].name == val) {
                    if (val == 'Email') profileVM.profileFields[i].template = profileVM.user.email;
                    else if (val == 'Name') profileVM.profileFields[i].template = profileVM.user.firstName + ' ' + profileVM.user.lastName;
                    // else if (val == 'Address')
                    //     profileVM.profileFields[i].template = profileVM.user.address.addressLine1 + ' ' + profileVM.user.address.country;
                    // else if (val == 'Contact')
                    //     profileVM.profileFields[i].template = profileVM.user.contact;
                    profileVM.profileFields[i].expanded = false;
                }
            }
        };
        function initProfileData(){
            profileVM.profileFields = [{
                name: 'Name',
                id: 'name',
                template: profileVM.user.FirstName + ' ' + profileVM.user.MiddleName + ' ' + profileVM.user.LastName,
                subFields: [{
                    name: 'First Name',
                    model: profileVM.user.FirstName,
                    id: 'firstName'
                }, {
                    name: 'Middle Name',
                    model: profileVM.user.MiddleName,
                    id: 'middleName'
                }, {
                    name: 'Last Name',
                    model: profileVM.user.LastName,
                    id: 'lastName'
                }],
                editable: false,
                expanded: false
            }, {
                id: 'email',
                name: 'Email',
                template: profileVM.user.EmailAddress,
                editable: false,
                expanded: false
            }, {
                id: 'TmXAddress',
                name: 'Address',
                template: profileVM.user.TmXAddress.AddressLine1,
                editable: false,
                subFields: [{
                    name: 'Address Line 1',
                    model: 'TmXAddress.AddressLine1',
                    id: 'AddressLine1'
                }, {
                    name: 'Address Line 2',
                    model: 'TmXAddress.AddressLine1',
                    id: 'AddressLine1'
                }, {
                    name: 'Address Line 3',
                    model: 'TmXAddress.AddressLine1',
                    id: 'AddressLine1'
                }, {
                    name: 'Address Line 4',
                    model: 'TmXAddress.AddressLine4',
                    id: 'AddressLine4'
                },
                [{
                    name: 'Country',
                    model: 'TmXAddress.country',
                    id: 'country',
                    type: 'select',
                    LOV: 'countries',
                    rowLayout: 'start'
                }, {
                    name: 'State',
                    model: 'TmXAddress.state',
                    id: 'state',
                    type: 'select',
                    LOV: 'states',
                    rowLayout: 'end'
                }],
                [{
                    name: 'City',
                    model: 'TmXAddress.city',
                    id: 'state',
                    type: 'select',
                    LOV: 'cities',
                    rowLayout: 'start'
                }, {
                    name: 'Zip Code',
                    model: 'TmXAddress.zipcode',
                    id: 'zipcode',
                    rowLayout: 'end'
                }]
                ],
                expanded: false
            },
            {
                id: 'contact',
                name: 'Contact',
                template: profileVM.user.contact,
                editable: false,
                subFields: [
                    {
                        name: 'Contact',
                        model: 'contact',
                        id: 'contact'
                    }
                ],
                expanded: false
            },
            {
                id: 'designation',
                name: 'Designation',
                template: profileVM.user.Designation,
                editable: false,
                expanded: false
            },
            {
                id: 'profileImage',
                name: 'ProfileImage',
                template: profileVM.user.ImageUrl,
                editable: false,
                expanded: false
            }
            ];
        }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function hide(){

            profileVM.hide=!profileVM.hide;
        }
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function init(data){

            if(ServerExceptionService.Displaymsg != ""){
                $scope.watch_count = 1;
            }
            //if(data.status.code == "200"){
            //    showCustomToast('success', data.status.message)
            //}
            getuser(data.data);
            initProfileData();
        }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function getuser(data){
            
            if(angular.isDefined(data) && data!= null){
                 

                profileVM.user=data;
                profileVM.user.Role = profileVM.user.UserRole;
                profileVM.user.Name = profileVM.user.FirstName + ' ' + profileVM.user.LastName;
                if(angular.isDefined(profileVM.user.TmXAddress) && profileVM.user.TmXAddress != null){
                    profileVM.user.TmXAddress.Address = "";
                    for(var property in profileVM.user.TmXAddress){
                         
                        if (profileVM.user.TmXAddress.hasOwnProperty(property) &&
                            profileVM.user.TmXAddress[property]!= null &&
                            profileVM.user.TmXAddress[property]!= undefined &&
                            profileVM.user.TmXAddress[property]!= "" &&
                            (property == "AddressLine1" ||
                            property == "AddressLine2" ||
                            property == "AddressLine3" ||
                            property == "AddressLine4" ||
                            property == "PostalZipCode")) {
                            // do stuff
                            profileVM.user.TmXAddress.Address =  profileVM.user.TmXAddress.Address + ' ' +
                                profileVM.user.TmXAddress[property]
                        }
                    }

                }

                var ImageEle = document.getElementById('profileImg');
                //checking if user imageURL is null or not
                 
                if(!angular.isDefined(profileVM.user.ImageUrl) || profileVM.user.ImageUrl==null || profileVM.user.ImageUrl==""){
                    profileVM.user.ImageUrl = "assets/images/profile.jpg"
                }
                //setting updated User in Service
                CurrentUserService.setUser(profileVM.user);
                //setting Current User in the local Storage
                profileVM.LocalStoreUser = CurrentUserService.getUserObject();
                profileVM.LocalStoreUser.firstName = profileVM.user.FirstName;
                profileVM.LocalStoreUser.lastName = profileVM.user.LastName;
                profileVM.LocalStoreUser.imageUrl = profileVM.user.ImageUrl;
                 
                localStorage.setItem("user", JSON.stringify(profileVM.LocalStoreUser));
                if(ImageEle != null){

                    ImageEle.src = profileVM.user.ImageUrl;
                }


                //profileVM.dataLoading=false;
                if(profileVM.user.TmXAddress==null)
                    profileVM.user.TmXAddress = {};
            }
        }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
         
        ProfileLinkService.getById(CurrentUserService.getUserObject().Id).then(init,function(){
        });

    }
})();